// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvolutionHistoryPanel_panel__9P\\+jB {
  padding: 18px 20px 20px;
}

.EvolutionHistoryPanel_header__oTwN9 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 12px;
}

.EvolutionHistoryPanel_header__oTwN9 h3 {
  margin: 0;
  color: #263746;
  font-size: 1rem;
}

.EvolutionHistoryPanel_header__oTwN9 p {
  margin: 5px 0 0;
  color: #73828d;
  font-size: .78rem;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 {
  display: inline-flex;
  gap: 8px;
  flex: 0 0 auto;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 button {
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 7px 11px;
  background: #f1f5f8;
  color: #587084;
  font: inherit;
  font-size: .78rem;
  cursor: pointer;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 button:hover,
.EvolutionHistoryPanel_modeSwitch__Ghxa9 button:focus-visible {
  border-color: #b9cad7;
  outline: none;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 .EvolutionHistoryPanel_activeMode__5n2fI {
  border-color: #155a70;
  background: #ffffff;
  color: #155a70;
  font-weight: 700;
}

.EvolutionHistoryPanel_state__ofiat,
.EvolutionHistoryPanel_error__oMqHR {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #71808b;
}

.EvolutionHistoryPanel_error__oMqHR {
  color: #b42318;
}

@media (max-width: 760px) {
  .EvolutionHistoryPanel_panel__9P\\+jB {
    padding: 14px;
  }

  .EvolutionHistoryPanel_header__oTwN9 {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/EvolutionHistoryPanel.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".panel {\r\n  padding: 18px 20px 20px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 18px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.header h3 {\r\n  margin: 0;\r\n  color: #263746;\r\n  font-size: 1rem;\r\n}\r\n\r\n.header p {\r\n  margin: 5px 0 0;\r\n  color: #73828d;\r\n  font-size: .78rem;\r\n}\r\n\r\n.modeSwitch {\r\n  display: inline-flex;\r\n  gap: 8px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.modeSwitch button {\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  padding: 7px 11px;\r\n  background: #f1f5f8;\r\n  color: #587084;\r\n  font: inherit;\r\n  font-size: .78rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.modeSwitch button:hover,\r\n.modeSwitch button:focus-visible {\r\n  border-color: #b9cad7;\r\n  outline: none;\r\n}\r\n\r\n.modeSwitch .activeMode {\r\n  border-color: #155a70;\r\n  background: #ffffff;\r\n  color: #155a70;\r\n  font-weight: 700;\r\n}\r\n\r\n.state,\r\n.error {\r\n  min-height: 260px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  color: #71808b;\r\n}\r\n\r\n.error {\r\n  color: #b42318;\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .panel {\r\n    padding: 14px;\r\n  }\r\n\r\n  .header {\r\n    flex-direction: column;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `EvolutionHistoryPanel_panel__9P+jB`,
	"header": `EvolutionHistoryPanel_header__oTwN9`,
	"modeSwitch": `EvolutionHistoryPanel_modeSwitch__Ghxa9`,
	"activeMode": `EvolutionHistoryPanel_activeMode__5n2fI`,
	"state": `EvolutionHistoryPanel_state__ofiat`,
	"error": `EvolutionHistoryPanel_error__oMqHR`
};
export default ___CSS_LOADER_EXPORT___;
